import { useState } from 'react';
import { Button } from '~/commonComponents';
import { DownloadReportPopup } from '../Popup';

export const DownloadReportButton = () => {
  const [isShowPopup, setIsShowPopup] = useState<boolean>(false);

  return (
    <>
      <Button
        dataCy="btn-export-report"
        text="Download Report"
        textStyle={{
          fontSize: 14,
          fontWeight: 700,
        }}
        style={{
          alignItems: 'center',
          borderRadius: 25,
          cursor: 'pointer',
          display: 'flex',
          height: 30,
          justifyContent: 'center',
          marginTop: 0,
          padding: '8px 16px',
          width: 'auto',
        }}
        onClick={() => setIsShowPopup(true)}
      />
      {isShowPopup && <DownloadReportPopup onClosePopup={() => setIsShowPopup(false)} />}
    </>
  );
};
